module.exports = __webpack_public_path__ + "assets/images/Sync4.78f1d2c5.jpg";